<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="大数据名称">
              <a-input placeholder="请输入大数据名称" v-model="queryParam.bigdataName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="大数据编号">
              <a-input placeholder="请输入大数据编号" v-model="queryParam.bigdataCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>


    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        filterMultiple="filterMultiple"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:type}"
        @change="handleTableChange"
        :customRow="clickThenCheck"
      >

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <!-- <a-divider type="vertical"/>
          <a-popconfirm title="确定启用选择的全部数据模拟吗?" @confirm="() => qyAll(record.id)">
            <a>启用</a>
          </a-popconfirm>

          <a-divider type="vertical"/>
          <a-popconfirm title="确定停用选择的全部数据模拟吗?" @confirm="() => tyAll(record.id)">
            <a>停用</a>
          </a-popconfirm> -->
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="数字统计类型" key="1">
        <Sys-Api-Mock-List ref="SysApiMockList"></Sys-Api-Mock-List>
      </a-tab-pane>
      <a-tab-pane tab="EchartsList类型" key="2" forceRender>
        <Sys-Api-Mock-List-List ref="SysApiMockListList"></Sys-Api-Mock-List-List>
      </a-tab-pane>
    </a-tabs>

    <!-- 表单区域 -->
    <sys-bigdata-modal ref="modalForm" @ok="modalFormOk"></sys-bigdata-modal>

  </a-card>
</template>
<script>
  import {deleteAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysBigdataModal from './modules/SysBigdataModal__Style#Drawer'
  import SysApiMockList from './SysApiMockList'
  import SysApiMockListList from './SysApiMockListList'

  export default {
    name: "SysBigDataList",
    mixins: [JeecgListMixin],
    components: {
      SysBigdataModal,
      SysApiMockList,
      SysApiMockListList
    },
    data() {
      return {
        description: '订单管理页面',
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 5,
          pageSizeOptions: ['5', '10', '20'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        // 表头
        columns: [
          {
            title:'大数据名称',
            align:"center",
            dataIndex: 'bigdataName'
          },
          {
            title:'大数据编号',
            align:"center",
            dataIndex: 'bigdataCode'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:140,
            scopedSlots: { customRender: 'action' }
          }
          ],
        // 分页参数
        type: "radio",
        url: {
         list: "/sys/sysbigdata/page",
          delete: "/sys/sysbigdata/delete",
          deleteBatch: "/sys/sysbigdata/delete/batch",
          exportXlsUrl: "/sys/sysbigdata/export/xls",
          importExcelUrl: "sys/sysbigdata/import/excel",
          qyAll: "sys/sysbigdata/qy/all",
          tyAll: "sys/sysbigdata/ty/all",
        },
      }
    },
    methods: {
      clickThenCheck(record) {
        return {
          on: {
            click: () => {
              this.onSelectChange(record.id.split(","), [record]);
            }
          }
        };
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.$refs.SysApiMockList.getOrderMain(this.selectedRowKeys[0]);
        this.$refs.SysApiMockListList.getOrderMain(this.selectedRowKeys[0]);
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
        this.$refs.SysApiMockList.queryParam.bigdataId = null;
        this.$refs.SysApiMockList.bigdataId = null;
        
        this.$refs.SysApiMockListList.queryParam.bigdataId = null;
        this.$refs.SysApiMockListList.bigdataId = null;
        
        this.$refs.SysApiMockList.mockDataType = "01";
        this.$refs.SysApiMockListList.mockDataType = "02";

        this.$refs.SysApiMockList.loadData();
        this.$refs.SysApiMockListList.loadData();

        this.$refs.SysApiMockList.selectedRowKeys = [];
        this.$refs.SysApiMockList.selectionRows = [];

        this.$refs.SysApiMockListList.selectedRowKeys = [];
        this.$refs.SysApiMockListList.selectionRows = [];
      },

      handleDelete: function (id) {
        var that = this;
        deleteAction(that.url.delete, {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
            this.$refs.SysApiMockList.loadData();
            this.$refs.SysApiMockListList.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      searchQuery:function(){
        this.selectedRowKeys = [];
        this.selectionRows = [];
        this.$refs.SysApiMockList.queryParam.bigdataId = null;
        this.$refs.SysApiMockListList.queryParam.bigdataId = null;
        
        this.$refs.SysApiMockList.mockDataType = "01";
        this.$refs.SysApiMockListList.mockDataType = "02";

        this.$refs.SysApiMockList.loadData();
        this.$refs.SysApiMockListList.loadData();

        this.$refs.SysApiMockList.selectedRowKeys = [];
        this.$refs.SysApiMockList.selectionRows = [];

        this.$refs.SysApiMockListList.selectedRowKeys = [];
        this.$refs.SysApiMockListList.selectionRows = [];
        this.loadData();
      },
      qyAll(id){   
        var that = this;
        getAction(that.url.qyAll, {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
            this.$refs.SysApiMockList.loadData();
            this.$refs.SysApiMockListList.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      tyAll(id){
        var that = this;
        getAction(that.url.tyAll, {id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
            this.$refs.SysApiMockList.mockDataType = "01";
            this.$refs.SysApiMockListList.mockDataType = "02";
            this.$refs.SysApiMockList.loadData();
            this.$refs.SysApiMockListList.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      }
    }
  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin-bottom: 18px;
  }

  .ant-table-tbody .ant-table-row td {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .anty-row-operator button {
    margin: 0 5px
  }

  .ant-btn-danger {
    background-color: #ffffff
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }
</style>
